import { JACKET_TYPE } from 'common/Jacket/types';
import { TOOLBAR_HEIGHT_SPACING } from 'common/Jacket/constants';

export {
  COLLAPSE_LEFT_PANE_WIDTH,
  COLLAPSE_SECTION_HEIGHT,
  COLLAPSE_SECTION_HEIGHT_EXAM_DETAILS,
  MIN_LEFT_PANE_WIDTH,
  MIN_SECTION_HEIGHT,
  MIN_SECTION_HEIGHT_EXAM_DETAILS,
  TAB_CONTENT_ADJUSTMENT_HEIGHT,
  TAB_HEIGHT,
  TOOLBAR_HEIGHT_SPACING,
  TOP_TABS_HEIGHT,
} from 'common/Jacket/constants';

export const PATIENT_JACKET_PADDING = 0;

// Padding/margin or any additional height adjustments for the PatientJacketContainer
export const PATIENT_JACKET_CONTAINER_SPACING = 12;
export const TOTAL_TOP_OFFSET = TOOLBAR_HEIGHT_SPACING + PATIENT_JACKET_CONTAINER_SPACING;

export type PatientJacketSection = {
  proportion: number;
};

export type PatientJacketResizableSection = {
  proportion: number;
  maxProportion: number;
};

export type PatientJacketSectionsMap = {
  priorsSummary: PatientJacketResizableSection;
  priors: PatientJacketSection;
  leftPane: PatientJacketResizableSection;
  exam: PatientJacketResizableSection;
  report: PatientJacketSection;
  patientJacket: PatientJacketResizableSection;
};

export const PATIENT_JACKET_DEFAULT_SECTIONS_MAP: PatientJacketSectionsMap = {
  priorsSummary: {
    proportion: 0.3,
    maxProportion: 0.7,
  },
  priors: {
    proportion: 0.7,
  },
  leftPane: {
    proportion: 0.6,
    maxProportion: 0.8,
  },
  exam: {
    proportion: 0.5,
    maxProportion: 0.7,
  },
  report: {
    proportion: 0.5,
  },
  patientJacket: {
    proportion: 0.6,
    maxProportion: 0.6,
  },
};

export const PATIENT_JACKET_LAYOUT_CONFIG = {
  jacketType: JACKET_TYPE.PATIENT,
  defaultSectionsMap: PATIENT_JACKET_DEFAULT_SECTIONS_MAP,
  totalTopOffset: TOTAL_TOP_OFFSET,
} as const;
